<template>
  <div class="analysis_warp">
    <div class="top">
      <img src="@/static/topCard/CaretCircleLeft.png"
           @click="back"
           alt="">
      <div style="margin-left: 42%;">AI快速检测</div>
    </div>
    <!-- <div class="middle">
      <img src="@/static/提示.png"
           style="margin-left: 32rem;"
           alt="">
      <div style=" margin-left: 10rem;
    display: flex;
    justify-content: space-between;
    width: 93%;">
        <div> 已完成的试卷，请前往我的试卷查看！</div>
        <div style="color: #2196F3;cursor: pointer;"
             @click="toMyPaper">点击前往</div>
      </div>
    </div> -->
    <div class="content">
      <div class="content_top">
        请选择你要检测的科目
      </div>
      <div class="content_middle">
        <div v-for="(item, index) in subjectList"
             :key="index"
             class="item"
             @click="handleClick(item,index)"
             :class="{ active: activeIndex == index }">
          {{ item.subject_name }}
        </div>

      </div>

    </div>
    <div class="content_bottom"
         @click="start">
      开始检测
    </div>
    <div ref="mod">
      <a-modal :get-container="() => $refs.mod"
               v-model:visible="visible"
               title="删除对话"
               style="width: 480rem;"
               ok-text="删除"
               cancel-text="取消">
        <p>删除后，对话将不可恢复。确认删除吗？</p>
        <template #footer>

          <a-button @click="handleCancel">取消</a-button>
          <a-button type="primary"
                    @click="delItem">确定</a-button>

        </template>
      </a-modal>
    </div>

  </div>

</template>

 
<script setup>

import { getUserSubject } from '@/api/subject.js'
import { addPost } from '@/api/post.js'
import { nextTick, onMounted, ref, reactive, onUnmounted } from 'vue'
import { getSkbSubject,getPaper } from '@/api/quick.js'
 import { message } from 'ant-design-vue'
 
import { useRoute, useRouter } from "vue-router";
import {  getStuSubjectList  } from '@/api/user.js'

const router = useRouter()


let route = useRoute()
let showWindow = ref(false)
let mapRef = ref()
let subject_id = ref('')
let userinfo = ref(null)
let ScoreRef = ref(null)
let userId = ref('')
let subjectIndex = ref(0)
let subjectList = ref([])
let activeIndex = ref(null)
let paper_duration = ref(0)
onMounted(() => {
  // getSubject()
  userinfo.value = JSON.parse(window.localStorage.getItem('userInfo'))
  userId.value = Number(userinfo.value.user_id)
  nextTick(() => {

  })
  getSubjectList()
})
const getSubjectList = async () => {
  const { data } = await getStuSubjectList({is_kujc:1})
  subjectList.value = data.list

}
const toMyPaper = () => {
  router.push('/quickPaper')
}

const start = async () => {
  if (subject_id.value == '') {
    message.error('请选择科目')
    return
  }
 
  const { data } = await getPaper({subject_id:subject_id.value})
  
  let form = {
edu_paper_id:data.edu_paper_id,
    is_kujc: 1
  }
      window.sessionStorage.removeItem('testpaperCardIndex')
  window.sessionStorage.removeItem('paper')
  window.sessionStorage.removeItem('images')
  router.push('/doPaper?isTeacherPaper=1' + '&form=' + JSON.stringify(form))


}
const back = () => {
  router.push('/index')
  // debugger
}
onUnmounted(() => {
  window.sessionStorage.removeItem("sessionNodeList")
})

// 点击笔记按钮
const handleClick = (item, index) => {

  activeIndex.value = index
  subject_id.value = item.subject_id
}

//发帖弹窗》提交
const submit = async () => {
  const { status } = await addPost(
    FormRef.value.form1
  )
  if (status == 200) {
    message.success('发帖成功')
    cancel()
  }

}


</script>
 
<style lang="scss" scoped>
.analysis_warp {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f6f6f6;

  .top {
    width: 1856rem;
    margin-top: 40rem;

    align-items: center;
    gap: 10rem;
    margin-left: 32rem;
    display: flex;
    border-radius: 32rem;
    background: #fff;
    height: 80rem;
    padding: 0 24rem;
    // justify-content: center;
    color: var(--light-333333, #333);
    text-align: center;

    font-size: 28rem;
    font-style: normal;
    font-weight: 600;
    line-height: 42rem; /* 150% */
  }
  .middle {
    img {
      width: 14rem;
      height: 14rem;
    }
    display: flex;
    width: 1200rem;
    margin-left: 360rem;
    height: 40rem;
    flex-shrink: 0;
    border-radius: 5rem;
    background: var(--Brand-Color_1, #e3f2fd);
    color: #000;
    text-align: center;
    align-items: center;
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem; /* 150% */
    margin-top: 32rem;
    margin-bottom: 32rem;
  }
  .content_bottom {
    display: flex;
    width: 1200rem;
    height: 56rem;
    padding: 8rem 28rem;
    justify-content: center;
    align-items: center;
    gap: 6rem;
    cursor: pointer;
    border-radius: var(--Radius-XS, 8rem);
    background: var(--Brand-Color_6default, #2196f3);
    color: var(--light-ffffff, #fff);
    text-align: center;
    margin-left: 19%;
    font-size: 24rem;
    margin-top: 36rem;
    font-style: normal;
    font-weight: 400;
    line-height: 36rem; /* 150% */
  }
  .content {
    margin-left: 360rem;
    width: 1200rem;
    height: 382rem;
    border-radius: 32rem;
    background: #fff;

    .content_middle {
      display: grid;
      width: 422rem;
      margin-left: 32%;
      height: 182rem;
      gap: 32rem;
      padding-top: 53rem;
      grid-template: repeat(3, 1fr) / repeat(3, 1fr);
      .active {
        color: #fff !important;
        background: var(--Brand-Color_6default, #2196f3) !important;
      }
      .item {
        color: var(--Brand-Color_6default, #2196f3);
        display: flex;
        font-size: 16rem;
        width: 112rem;
        height: 40rem;
        // padding: 6rem 20rem;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        flex-shrink: 0;
        // grid-row: 1 / span 1;
        // grid-column: 1 / span 1;
        border-radius: var(--Radius-XS, 8rem);
        border: 1rem solid var(--2196-f-3, #2196f3);
        background: var(--light-ffffff, #fff);
      }
    }
    .content_top {
      display: flex;

      padding-top: 53rem;

      margin-top: 52rem;
      flex-direction: column;
      align-items: center;
      gap: 40rem;
      flex-shrink: 0;
      overflow: hidden;
      color: var(--light-333333, #333);
      text-align: center;
      text-overflow: ellipsis;

      font-size: 24rem;
      font-style: normal;
      font-weight: 600;
      line-height: 36rem; /* 150% */
    }
  }
}
.fixed_btn {
  position: fixed;
  top: 50rem;
  right: 30rem;
  font-size: 24rem;
  display: flex;
  // width: 350rem;
  div {
    // flex: 1;
    text-align: center;
  }
  img {
    width: 36rem;
    height: 36rem;
    margin-left: 30rem;
  }
}
</style>